export const hasNumberValue = (value?: number) =>
  value && value > 0 ? true : false;
